import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function customMinValidator(minValue?: number): ValidatorFn {


  return (control: AbstractControl): ValidationErrors | null => {


    const value = String(control.value).replace(/\./g, '');

    if (Number(value) < minValue) {
        return { cusMin: true };        
    }

    return null;

  }
}
